/**
 * This reducer is used for fetching batch allocations
 */
import {
    GET_BATCH_ALLOCATIONS,
    GET_BATCH_ALLOCATIONS_SUCCESS,
    GET_BATCH_ALLOCATIONS_FAILURE,
} from '../actions';

const initialState = {
    batchAllocations: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const batchAllocationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BATCH_ALLOCATIONS:
            return {
                ...state,
                loading: true,
            };
        case GET_BATCH_ALLOCATIONS_SUCCESS:
            return {
                ...state,
                batchAllocations: [
                    ...state.batchAllocations,
                    ...action.payload,
                ],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_BATCH_ALLOCATIONS_FAILURE:
            return {
                ...state,
                batchAllocations: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };

        default: {
            return { ...state };
        }
    }
};

export default batchAllocationsReducer;
